$(document).ready(function () {
  var hash = location.hash.replace(/#/, '');

  if (hash) {
    const triggerEl = document.querySelector('.nav-item a[href="#' + hash + '"]');
    triggerEl.click();
    history.replaceState('', document.title, window.location.origin + window.location.pathname + window.location.search);
    setTimeout(() => {window.scroll(0, triggerEl.getBoundingClientRect().top - 110)}, 350);
  }
});
